import React from 'react';
import { 
  Heart, 
  Shield, 
  Scale,
  Briefcase, 
  Hammer,
  FileText, 
  Building, 
  Landmark,
  Globe,
  Building2,
  TrendingUp,
  Calculator,
  ChevronDown
} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import { services } from '../data/mockData';

const iconMap = {
  Heart,
  Shield,
  Scale,
  Briefcase,
  Gavel: Hammer,
  FileText,
  Building,
  Landmark,
  Globe,
  Building2,
  TrendingUp,
  Calculator,
};

const ServicesSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="services" className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #c4a35a 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1d2e] mb-4">
            {t.servicesTitle}
          </h2>
          <div className="w-20 h-1 bg-[#c4a35a] mx-auto mb-6" />
          <p className="text-gray-600 text-lg">
            {t.servicesSubtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            const titleKey = service.key;
            const descKey = `${service.key}Desc`;
            
            return (
              <div
                key={service.id}
                className="group bg-[#1a1d2e] border border-[#c4a35a]/30 rounded-xl p-6 hover:border-[#c4a35a]/60 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-[#c4a35a]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#c4a35a]/20 group-hover:scale-110 transition-all duration-300">
                    <Icon className="w-7 h-7 text-[#c4a35a]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#c4a35a] transition-colors">
                      {t[titleKey]}
                    </h3>
                  </div>
                  <ChevronDown className="w-5 h-5 text-[#c4a35a] flex-shrink-0 mt-1 group-hover:translate-y-1 transition-transform" />
                </div>
                <p className="text-gray-300 text-sm leading-relaxed mt-4">
                  {t[descKey]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
